import $ from 'jquery'

function spotlight(el) {
	el = $(el)
	el.addClass('is-spotlighted')
		.one('transitionend', () => {
			// note: this causes another animation to start (the yellow fades
			// to not yellow anymore)
			el.removeClass('is-spotlighted')
		})
}

export default spotlight

spotlight.__filename__ = 'components/spotlight.js'
